import getBlobURL from '../../../../../../../utility/action-images/getBlob/getBlobURL';
import getPresignURLController from '../../../../../../../utility/getPresignURLController';
import getToken from '../../../../../../../utility/getToken';
import userToken from '../../../../../../../utility/resume/userToken';

export const getData = (data) => {
  let parsedNodeData = data;
  const parsedObject = {};
  if (parsedNodeData && !parsedNodeData.path) {
    const parsedArray = parsedNodeData.toArray();
    parsedArray.forEach(([srvKey, value]) => {
      parsedObject[srvKey] = value;
    });
    parsedNodeData = parsedObject;
  }
  return parsedNodeData;
};

export const urlUpdator = (imageParsedData, blobURLs, blobURL, setState) => {
  if (
    imageParsedData &&
    imageParsedData.path &&
    blobURLs &&
    blobURLs[imageParsedData.path] &&
    blobURLs[imageParsedData.path] !== blobURL
  ) {
    setState({ blobURL: blobURLs[imageParsedData.path] });
  } else if (!imageParsedData && blobURL) {
    setState({ blobURL: null });
  }
};

export const getBlobData = async (imageParsedData, blobURLs) => {
  const { path, type } = imageParsedData;

  const data = {
    name: path,
    contentType: type,
    methodType: 'getObject',
  };
  const isBlobPresent = blobURLs[path];
  if (isBlobPresent) {
    return { blobURL: isBlobPresent, isPresent: false };
  }
  const token = await getToken();
  const imageURL = await getPresignURLController.getPresignedURL(data, token);
  const blobURL = await getBlobURL(imageURL, type);
  return { blobURL, isPresent: false };
};

export const getPreviewBlob = async (imageData) => {
  const path = imageData.imageURL.get('path');
  const type = imageData.imageURL && imageData.imageURL.get('type');

  const data = {
    name: path,
    contentType: type,
    methodType: 'getObject',
  };
  const userTokenArray = userToken();
  const token = userTokenArray[1];
  const jwtToken = await getToken();
  const imageURL = await getPresignURLController.getPresignedURL(
    data,
    token || jwtToken,
  );

  const blobURL = await getBlobURL(imageURL, type);

  return blobURL;
};
